export default "__VITE_ASSET__C7km6Lpq__"